import { Flex } from '@/components/Common';
import { LayoutHierarchy } from '@/constants';
import ArrowUpSvgIcon from '@/public/images/icons/arrow_up.svg';
import CloseSvgIcon from '@/public/images/icons/close_icon.svg';
import { IconButton } from '@radix-ui/themes';
import styled from 'styled-components';

export const PopupContainer = styled(Flex)<{ isExpanded?: boolean }>(({ theme, isExpanded }) => ({
  position: 'fixed',
  zIndex: LayoutHierarchy.Sixth,
  bottom: 0,
  right: 0,
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.colors.darkBlue,
  transition: 'height 0.2s linear',
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  overflow: 'hidden',

  [`${theme.mediaBreakpointUp.lg}`]: {
    alignItems: 'flex-start',
    bottom: 100,
    right: 32,
    flexDirection: 'row',
    width: isExpanded !== false ? 570 : 265,
    transition: 'width 0.2s linear',
    borderRadius: 8,
    boxShadow: theme.elevation[5],
  },
}));

export const StyledIconButton = styled(IconButton)({
  border: 'none',
  background: 'transparent',
  display: 'flex',
  padding: 0,
  position: 'absolute',
  top: 20,
  right: 12,
  cursor: 'pointer',
  width: 'fit-content',
  height: 'fit-content',
});

export const CloseIcon = styled(CloseSvgIcon).attrs({ width: 20, height: 20 })(({ theme }) => ({
  path: {
    fill: theme.colors.mediumEmphasisWhite,
  },
}));

export const ArrowUpIcon = styled(ArrowUpSvgIcon).attrs({ width: 20, height: 20 })(({ theme }) => ({
  path: {
    fill: theme.colors.mediumEmphasisWhite,
    fillOpacity: 'unset',
  },
}));
